/* eslint-disable camelcase */
import en from './en';
import es from './es';

export const langs: Record<string, Record<string, string>> = {
  en,
  es,
};
